import React, { useState } from "react";
import { Phone, Mail, MapPin, MessageCircle, Check } from "lucide-react";
import { toast } from "sonner";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import api from "@/lib/api";
import { IMG, CONTACT } from "@/data/site";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) { toast.error("Please complete name, email and message."); return; }
    try {
      await api.post("/enquiries", { kind: "contact", name: form.name, email: form.email, phone: form.phone, message: form.message });
      setDone(true);
      toast.success("Message sent!");
    } catch (err) { toast.error("Could not send. Please try again."); }
  };

  return (
    <div data-testid="contact-page">
      <Seo title="Contact Rossi Ceramics" description="Contact Rossi Ceramics in Stockport — call Vincent Rossi on 0749215555 or email info@rossiceramics.co.uk." />
      <PageHero eyebrow="Get in touch" title="Contact Rossi Ceramics" subtitle="We'd love to hear about your project. Call, email or send us a message." image={IMG.kitchen[1]} />

      <section className="container-rossi py-16 grid lg:grid-cols-2 gap-10 max-w-6xl">
        <div className="space-y-4">
          {[[Phone, "Phone", CONTACT.phone, CONTACT.phoneHref], [Mail, "Email", CONTACT.email, `mailto:${CONTACT.email}`], [MessageCircle, "WhatsApp", "Message us", CONTACT.whatsapp]].map(([Icon, label, val, href]) => (
            <a key={label} href={href} className="card-lux p-6 flex items-center gap-4 hover:border-rossi-gold/40 transition-colors" data-testid={`contact-${label.toLowerCase()}`}>
              <span className="h-12 w-12 rounded-full bg-rossi-gold/15 flex items-center justify-center"><Icon size={22} className="text-rossi-gold" /></span>
              <div><p className="text-xs text-rossi-stone font-mono uppercase tracking-widest">{label}</p><p className="text-rossi-cream text-lg">{val}</p></div>
            </a>
          ))}
          <div className="card-lux p-6 flex items-center gap-4">
            <span className="h-12 w-12 rounded-full bg-rossi-gold/15 flex items-center justify-center"><MapPin size={22} className="text-rossi-gold" /></span>
            <div><p className="text-xs text-rossi-stone font-mono uppercase tracking-widest">Service area</p><p className="text-rossi-cream text-lg">{CONTACT.location}</p><p className="text-sm text-rossi-stone">Owner: {CONTACT.owner}</p></div>
          </div>
        </div>

        <div className="card-lux p-7">
          {done ? (
            <div className="py-16 text-center" data-testid="contact-done"><Check size={40} className="text-rossi-gold mx-auto" /><h3 className="font-serif text-2xl text-rossi-cream mt-4">Message sent</h3><p className="text-sm text-rossi-cream/70 mt-2">Thanks {form.name.split(" ")[0]}, we'll be in touch shortly.</p></div>
          ) : (
            <form onSubmit={submit}>
              <h2 className="font-serif text-2xl text-rossi-cream mb-5">Send a message</h2>
              <div className="space-y-3">
                <input placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full bg-rossi-bg border border-white/10 rounded-lg px-3 py-2.5 text-sm text-rossi-cream focus:outline-none focus:border-rossi-gold/50" data-testid="contact-name" />
                <input placeholder="Email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full bg-rossi-bg border border-white/10 rounded-lg px-3 py-2.5 text-sm text-rossi-cream focus:outline-none focus:border-rossi-gold/50" data-testid="contact-email" />
                <input placeholder="Phone (optional)" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="w-full bg-rossi-bg border border-white/10 rounded-lg px-3 py-2.5 text-sm text-rossi-cream focus:outline-none focus:border-rossi-gold/50" data-testid="contact-phone" />
                <textarea placeholder="How can we help?" rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full bg-rossi-bg border border-white/10 rounded-lg px-3 py-2.5 text-sm text-rossi-cream focus:outline-none focus:border-rossi-gold/50" data-testid="contact-message" />
              </div>
              <button type="submit" className="btn-gold w-full mt-5" data-testid="contact-submit">Send message</button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}
